import React, { useState } from 'react';
import { Divider } from 'antd';
import { CardWrap } from '../assets/styled-components';
import { strings } from '../assets/strings';
import styles from '../assets/CardWrapHighlight.module.css';
import { AttachmentsList } from '../components/AttachmentsList';
import { GeneralQuestion } from '../components/GeneralQuestion';

export const Attachments = (props) => {
  const {
    selectable,
    readOnly,
    generalSelections,
    attachments,
    dataRoomId,
    setRefresh,
  } = props;

  const [generalQuestionChecked, setGeneralQuestionChecked] = useState(false);

  return (
    <CardWrap
      className={
        generalQuestionChecked && selectable
          ? styles.checked
          : styles.notChecked
      }
    >
      <GeneralQuestion
        title={strings.dataset_details.attachments}
        selectable={selectable}
        readOnly={readOnly}
        generalSelections={generalSelections}
        category={strings.discussion_threads_categories.attachments}
        dataRoomId={dataRoomId}
        setRefresh={setRefresh}
        setGeneralQuestionChecked={setGeneralQuestionChecked}
      ></GeneralQuestion>
      <Divider style={{ margin: '0', padding: '10px 0' }} />
      <AttachmentsList attachments={attachments}></AttachmentsList>
    </CardWrap>
  );
};
